// extracted by mini-css-extract-plugin
export var typingIndicator = "_pe-0";